// removed by extract-text-webpack-plugin
module.exports = {"infoMessage":"InfoMessage__infoMessage___WsE2z","message":"InfoMessage__message___1AsDQ","instructions":"InfoMessage__instructions___1ucB_","text":"InfoMessage__text___r8bdd","image":"InfoMessage__image___1-9aL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoMessage/InfoMessage.css
// module id = 704
// module chunks = 0